export default __webpack_public_path__ + "static/media/ivory-coast.e5c843a5.png";